<template>
  <div class="zj-moble-app-page">
    <mt-header class="zj-mt-header" fixed="true" slot="left">
      <mt-button slot="left" icon="back" class="nav-btn">任务详情</mt-button>
    </mt-header>
    <div class="zj-mt-content">
      <div class="zj-mt-map">
        <ZJMobileApp></ZJMobileApp>
      </div>
      <div class="zj-mt-taskinfo">
        <mt-cell title="任务详情：" :label="Task.TaskTiltle">
          <img
            class="iconLeft"
            slot="icon"
            src="../images/icon1.png"
          />
        </mt-cell>
        <mt-cell title="任务描述：" :label="Task.TaskDesc">
          <img
            class="iconLeft"
            slot="icon"
            src="../images/icon2.png"
          />
        </mt-cell>
        <mt-cell title="任务地址：" :label="Task.Location">
          <img
            class="iconLeft"
            slot="icon"
            src="../images/icon3.png"
          />
        </mt-cell>
        <mt-cell title="负责人：" :label="ChargerPerson">
          <img
            class="iconLeft"
            slot="icon"
            src="../images/icon4.png"
          />
        </mt-cell>
        <mt-cell title="计划响应时间：" :label="PlanResponseTimeStr">
          <img
            class="iconLeft"
            slot="icon"
            src="../images/icon5.png"
          />
        </mt-cell>
      </div>
      <!-- <div class="zj-mt-rescueteam">涉及救援队人员</div> -->
    </div>
    <div class="zj-mt-footer">
      <mt-button type="primary" class="btnsubmit" @click.native="IsVisible = true" size="large">任务反馈</mt-button>
    </div>
    <mt-popup v-model="IsVisible" position="bottom" class="mint-popup">
      <mt-header title="任务反馈"></mt-header>
      <div class="filed-label">执行状态</div>
      <div class="filed-label">
        <mt-button
          size="small"
          :class="{active:Finshed}"
          @click.native="OnExecStatusChanged('2')"
        >已完成</mt-button>
        <mt-button
          size="small"
          :class="{active:Unfinished}"
          @click.native="OnExecStatusChanged('1')"
        >未完成</mt-button>
      </div>
      <div class="filed-label">反馈内容</div>
      <mt-field
        label
        placeholder="填写任务执行情况的说明"
        type="textarea"
        rows="4"
        v-model="Task.FeedbackDesc"
      ></mt-field>
      <mt-button class="popup-submit" type="primary" size="large" @click.native="submitFeedback">提交</mt-button>
    </mt-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Field, Cell, Toast, Indicator } from "mint-ui";
import MyApis from "../../../../../plugins/emergency/src/apis";
import ZJApp from "../../../app";

import ZJMobileApp from "./component/map.vue";

Vue.component(Field.name, Field);
Vue.component(Cell.name, Cell);

export default {
  name: "EmgTaskCenter",
  controller: "UI",
  action: "TaskCenter",
  components: {
    ZJMobileApp
  },
  props: {
    query: {
      //任务执行id
      ExecutTaskId: {
        type: String,
        require: true,
        default: ""
      }
    } 
  },
  data: function() {
    return {
      Finshed: false,
      Unfinished: false,
      Task: {
        ExecutId: "",
        TaskTiltle: "",
        TaskDesc: "",
        Location: "",
        PlanResponseTime: "",
        ChargerName: "",
        Phone: "",
        Longitude: "",
        Latitude: "",
        ExecStatus: "",
        FeedbackDesc: ""
      },
      IsVisible: false,
      // AddressBookObj: null,
      // EventObj: null,
      // FeedBackMsg: "",
      msgkey: {
        emergencyFeedbackKey: "MessageKey_EmergencyFeedBack",
        emergencyFinishTaskKey: "MessageKey_EmergencyFinishTask"
      }
    };
  },
  created() {
    // this.executTaskId = this.$route.query.ExecutTaskId;
    // this.book_id = this.$route.query.BookId;
    // this.event_id = this.$route.query.EventId;
    this.Init();
  },
  methods: {
    Init() {
      Indicator.open("加载中...");
      return ZJApp.ZJUtils.waitAll([
        () => this.GetTask()
      ]).then(() => {
        Indicator.close();
      });
    },
    GetTask() {
      let ExecutTaskSearch = {
        ExecutTaskId: this.query.ExecutTaskId,
        Validity: 1
      };
      let that = this;
      return new MyApis.ExecutTaskApi()
        .GetItemById(ExecutTaskSearch)
        .then(res => {
          if (res.RspCode == "1" && res.data.Data != null) {
            var result = res.data.Data;
            // eslint-disable-next-line no-undef
            that.Task = $.extend({}, that.Task, result);
          }
        })
        .catch(e => {
          //Toast(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          console.log(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    OnExecStatusChanged(val) {
      this.Task.ExecStatus = val;
      this.Task.TaskStatus = val;
      this.Finshed = val == 2;
      this.Unfinished = val == 1;
    },
    submitFeedback() {
      let that = this;

      if (!that.Task.ExecStatus) {
        Toast({ message: "请反馈执行状态" });
        return false;
      }

      //插入反馈数据
      new MyApis.ExecutFeedbackApi()
        .AddItem(that.feedback)
        .then(r => {
          let data = r.data.Data;
          if (data) {
            //增加反馈成功，发送反馈成功消息
            that.$notify.broadcase({
              key: that.msgkey.emergencyFeedbackKey + that.Task.ExecutId,
              data: that.feedback
            });

            //更新任务状态
            new MyApis.ExecutTaskApi()
              .UpdateItem(that.Task)
              .then(r => {
                let data = r.data.Data;
                if (data) {
                  //发送任务完成消息
                  console.log(
                    "broadcase : " +
                      that.msgkey.emergencyFinishTaskKey +
                      that.Task.ExecutId
                  );
                  that.$notify.broadcase({
                    key:
                      that.msgkey.emergencyFinishTaskKey + that.Task.ExecutId,
                    data: that.Task
                  });

                  this.IsVisible = false;

                  Toast({ message: "任务反馈成功" });
                } else {
                  Toast({ message: "更新任务状态失败" });
                }
              })
              .catch(e => {
                console.error(e);
                Toast({ message: e.RspMsg ? e.RspMsg : "更新任务状态失败" });
              });
          } else {
            Toast({ message: r.RspMsg ? r.RspMsg : "任务反馈失败！" });
          }
        })
        .catch(e => {
          console.error(e);
          Toast({ message: e.RspMsg ? e.RspMsg : "任务反馈失败！" });
        });
    }
  },
  computed: {
    ChargerPerson: function() {
      return this.Task.ChargerName + " " + this.Task.Phone;
    },
    PlanResponseTimeStr: function() {
      return this.Task.PlanResponseTime + "分钟";
    },
    feedback: function() {
      let uuid = ZJApp.ZJUtils.uuid();
      let deptId = this.Task.OrgId;
      let user = this.Task.ChargerName;
      var feedback = {
        Creater: user,
        Modifier: user,
        CreateTime: new Date(),
        ModifyTime: new Date(),
        Validity: 1,
        OrgId: deptId,
        FeedbackId: uuid,
        ExecutId: this.Task.ExecutId,
        ExecutTaskId: this.Task.ExecutTaskId,
        TaskTiltle: this.Task.TaskTiltle,
        TaskDesc: this.Task.TaskDesc,
        FeedType: "1", //反馈类型(1-事件反馈2-事态上报)
        Charger: this.Task.ChargerName,
        TelPhone: this.Task.Phone,
        PlanResponseTime: this.Task.PlanResponseTime,
        ExecStatus: this.Task.ExecStatus,
        FeedbackDesc: this.Task.FeedbackDesc
      };
      return feedback;
    }
  }
};
</script>
<style lang="scss" scoped>
.iconLeft{
  width:0.54rem;
  height:0.72rem;
}
.btnsubmit{
  font-size: 0.28rem;
}
</style>